import { LayoutModule } from '../../../../layout/modules';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Box } from '@mui/material';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PRODUCT,
    PRODUCT_EDIT,
    PRODUCT_NEW,
    PRODUCT_DETAIL,
} from '../../../../../routes/paths';

import { useProductDetail } from './hook';
import { ProductData } from './data';
import { ProductRegisterHistory } from './registerHistory';
import { ProductHistorical } from '../historical';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const ProductDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const {
        product,
        loading,
        productHistorical,
        showHistorical,
        setShowHistorical,
    } = useProductDetail();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle producto"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={product?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PRODUCT_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PRODUCT,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: PRODUCT_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PRODUCT_DETAIL,
                        }}
                        buttonLog={{
                            show: true,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <ProductHistorical
                            historical={productHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Proceso"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
                >
                    <ProductData product={product} loading={loading} />
                </LayoutModule>
            </LayoutModule>
            <ProductRegisterHistory product={product} />
        </>
    );
};
